export default __webpack_public_path__ + "static/media/ob-02.0c90762b.svg";